module.exports = __webpack_public_path__ + "img/u1841.00ac928d.png";